import React from 'react';
import darkBackground from '../assets/tinkerlabs__web__dark_hatter.webp';
import astronautLeft from '../assets/tinkerlabs__web__fig1.webp';
import astronautRight from '../assets/tinkerlabs__web__fig2.webp';
import photo1 from '../assets/Fotografija_3-min.png';

const WhyTinkerLabs = ({toSection,section}) => {

  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const reasons = [
    {
      title: "Market innovators",
      description: "Tinker Labs programs are the only truly cohesive and fully developed STEAM integration learning courses on the market, with courses and bespoke learning materials that enhance critical thinking, strengthen problem-solving abilities, and boost academic success through practical learning and fun experiments."},
    {
      title: "Growing Demand for STEAM Education",
      description: "Parents, educators, and communities across the world recognize the need for strong STEAM foundations to help children succeed. By joining Tinker Labs, you’re tapping into a high-demand, fragmented market."
    },
    {
      title: "Play, passion, purpose",
      description: "Kids as young as 3 can be students at Tinker Labs, and with 7 years of continuous courses that children actually enjoy, our high retention rates allow for franchise success."},
    {
      title: "Let us guide you to success",
      description: "We ensure a turnkey business system, which means we'll provide comprehensive training with business and pedagogic support."
    }
  ];

  return (
    <div style={{marginTop:'-180px',zIndex:1}} id={section} className="relative">
      {/* Main content */}
      <div style={{backgroundColor:'rgb(255 255 255 / 0%)'}} className="bg-[#fff] min-h-[93vh] relative">
        {/* Background with stars */}
        <div className="absolute inset-0">
          <img 
            src={darkBackground}
            alt="Starry background" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* Floating astronauts */}
        <div className="absolute left-40 top-1/2 -translate-y-1/2 z-10">
          <img 
            src={astronautLeft}
            alt="Left floating astronaut" 
            className="w-40 h-auto animate-float"
          />
        </div>
        <div className="absolute right-40 top-1/2 -translate-y-1/2 z-10">
          <img 
            src={astronautRight}
            alt="Right floating astronaut" 
            className="w-40 h-auto animate-float-delayed"
          />
        </div>

        {/* Content container - White box with shadow */}
        <div className="relative z-10 container mx-auto px-2 py-20">
        <div className="container mx-auto px-4">
        <div  className="grid md:grid-cols-2 gap-12 ">
              {/* Text content */}
              <div className="bg-white bg-white rounded-2xl shadow-xl grid md:grid-cols-1 gap-4 p-10">
              <h2 className="font-['Grandstander'] text-[#002147] text-2xl font-extrabold mb-4 text-center">
              Why Tinker Labs?
            </h2>
              {reasons.map((reason, index) => (
                <div 
                  key={index}
                  className="  rounded-xl transition-all duration-300"
                >
                  <h3 className="font-['Lexend'] text-xl font-semibold mb-1 text-[#1678F2]">
                    {reason.title}
                  </h3>
                  <p className="font-['Lexend'] text-sm text-[#002147]">
                    {reason.description}
                  </p>
                </div>
              ))}
                <div className="text-center mt-2 pb-10">
              <button onClick={scrollToForm} className="bg-[#FF6B2C] text-white px-2 py-3 rounded-[50px] font-['Lexend'] font-semibold hover:bg-[#FF5A1F] transition-all">
                Request a Franchise Informational Brochure
              </button>
            </div>
            </div>

              {/* Image side */}
              <div className="bg-white bg-white rounded-2xl shadow-xl relative h-full">
                <img 
                  src={photo1} 
                  alt="Children learning" 
                  className="h-full w-auto rounded-lg shadow-lg"
                  style={{objectFit:'cover'}}
                />
              </div>
            </div>
            

          
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes floatDelayed {
          0%, 100% { transform: translateY(-20px); }
          50% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: floatDelayed 6s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default WhyTinkerLabs;